import React, { useState } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import Icon from '../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../Shared/TextInput';
import TextArea from '../../../Shared/TextArea';
import LoadingButton from '../../../Shared/LoadingButton';
import axios from 'axios';

function Package() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [saved, setSaved] = useState(false);
     console.log(data);
     const [values, setValues] = useState({
          checkAll: false,
          checkAllCaption: 'Select All',
          errors: errors,
          items: data.items || [],
          itemsShow: data.itemsShow || [],
          filterArr: data.products || [],
          search: ''
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          const _data = parseInt(e.target.value);
          let item = {};
          for(var i = 0; i < values.filterArr.length; i++){
               if(values.filterArr[i].id == _data){
                    values.filterArr[i].checked = value;
                    values.filterArr[i].isCheck = value;
                    item = values.filterArr[i];
                    break;
               }
          }

          let prods = values.items;
          let _prod = values.itemsShow;
          if(prods.indexOf(_data) != -1){
               _prod.splice(prods.indexOf(_data), 1);
               prods.splice(prods.indexOf(_data), 1);
          }else{
               prods.push(_data);
               _prod.push(item);
          }
          console.log(key, value, prods);
          setValues(values => ({
               ...values,
               items: prods,
               itemsShow: _prod
          }));
     }

     function handleSearch(e){
          let value = e.target.value;
          if(value == ''){
               setValues(values => ({
                    ...values,
                    filterArr: data.products,
                    search: value
               }));
          }else{
               let filteredArr = values.filterArr.filter((product) => product.name.includes(value));
               setValues(values => ({
                    ...values,
                    filterArr: filteredArr,
                    search: value
               }));
          }
     }

     function handleAll(e){
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          console.log(key, value);
          let prods = [];
          let _prods = [];
          let caption = (value) ? 'Unselect All' : 'Select All';
          for(var i = 0; i < values.filterArr.length; i++){
               if(value){
                    prods.push(values.filterArr[i].id);
                    _prods.push(values.filterArr[i]);
               }
               values.filterArr[i].isCheck = value;
          }
          if(!value){
               prods = [];
               _prods = [];
          }
          console.log(prods);
          setValues(values => ({
               ...values,
               items: prods,
               itemsShow: _prods
          }));
     }

     function handleQty(e, i){
          let value = e.data;
          let items = values.itemsShow;
          items[i].qty = value;
          setValues(values => ({
               ...values,
               itemsShow: items
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          console.log(values);
          Inertia.post(route('package.store', data.package.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="assign-perms">
               <Helmet>
                    <title>Create Package</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-md font-medium text-gray-600">Add Items to</h3>
                              <h3 className="text-lg font-medium text-gray-700 mt-3">{data.package.name} ({data.package.code})</h3>
                              <p className="mt-1 text-sm text-gray-600">
                                   {data.package.description}
                              </p>
                              <ul className="list-none pt-2 mt-2">
                                   {values.itemsShow.map(({id, name, code, type, description, qty, isCheck}, i) => {
                                        return <li className={`p-2 mt-2 rounded hover:shadow-md ${(isCheck?'bg-white':'')}`} key={`s-${i}`}>
                                             <label className="flex items-center" htmlFor="perms">
                                                  <input name="products[]" id="products[]" className="form-checkbox" type="checkbox" value={id} checked={isCheck} onChange={handleChange}/>
                                                  <span className="font-semibold ml-2 text-sm text-gray-700">{name} ({code})</span>
                                             </label>
                                             <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                   label="Quantity"
                                                   name="qty"
                                                   type="number"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.search}
                                                   value={values.itemsShow[i].qty}
                                                   onChange={()=>handleQty(event, i)}
                                              />
                                        </li>
                                   })}
                              </ul>
                         </div>
                    </div>
                    <DataCard>
                         <form onSubmit={handleSubmit}>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('product.index')} className="bg-transparent border border-gray-500 text-sm text-gray-500 p-2 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100 inline-flex items-center">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="sm:col-span-4">
                                             <div className="flex mt-4">
                                                  <TextInput
                                                        className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                        label="Search Products"
                                                        name="search"
                                                        type="text"
                                                        disable={false}
                                                        readonly={false}
                                                        errors={errors.search}
                                                        value={values.search}
                                                        onChange={handleSearch}
                                                   />
                                             </div>
                                             <div className="flex mt-4">
                                                  <label className="flex items-center mr-4" htmlFor="perms">
                                                       <input name="checkAll" id="checkAll" className="form-checkbox" type="checkbox" checked={values.chekcAll} onChange={handleAll}/>
                                                       <span className="ml-2 text-sm text-gray-600">{values.checkAllCaption}</span>
                                                  </label>
                                             </div>
                                             <ul className="overflow-auto h-128 list-none pt-2 mt-2">
                                                  {values.filterArr.map(({id, name, code, type, description, isCheck}) => {
                                                       return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md ${(isCheck?'bg-blue-200':'')}`} key={id}>
                                                            <label className="flex items-center" htmlFor="perms">
                                                                 <input name="products[]" id="products[]" className="form-checkbox" type="checkbox" value={id} checked={isCheck} onChange={handleChange}/>
                                                                 <span className="font-semibold ml-2 text-sm text-gray-700">{name} ({code})</span>
                                                            </label>
                                                            <p className="text-gray-400 pl-6">{type}</p>
                                                            <p className="text-sm text-gray-500 pl-6">{description}</p>
                                                       </li>
                                                  })}
                                             </ul>
                                        </div>
                                   </div>
                              </div>
                              <div className="flex items-center justify-end px-4 py-3 bg-gray-100 text-right sm:px-6 rounded-b">
                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                        Save Package
                                   </LoadingButton>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Package.layout = page => <AdminLayout children={page} header={'Create Package'} />;

export default Package;
